import { render, staticRenderFns } from "./StaticText.vue?vue&type=template&id=181c9799&"
import script from "./StaticText.vue?vue&type=script&lang=babel&"
export * from "./StaticText.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports